<template>
  <div class="web">
    <div class="received">
      <!-- 筛选 -->
      <el-form ref="form" :model="searchForm" label-width="80px" inline>
        <el-form-item>
          <el-select v-model="searchForm.is_read" placeholder="状态">
            <el-option
              :label="item.name"
              :value="item.active"
              v-for="(item, index) in is_readList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.jid" placeholder="职位">
            <el-option
              :label="item.job_name"
              :value="item.jid"
              v-for="(item, index) in jobList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 列表 -->
    <div class="list" v-loading="loading">
      <div class="listBox" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
        <div class="listTop clearfix">
          <div class="listTopBox fl">
            <div class="is_read">{{item.is_read === 1?'已阅':'未阅'}}</div>
            <div class="createTime">{{item.createTime}}</div>
            <div>
              <el-avatar :size="64" :src="item.avatar"></el-avatar>
            </div>
            <div class="listContent">
              <div class="vita_name">{{item.vita_name}}</div>
              <div class="listContentBox">
                <span>{{item.province_name?item.province_name:''}}{{item.city_name?item.city_name:''}}{{item.dist_name?item.dist_name:''}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.worktime}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.education}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.desired_position}}</span>
              </div>
            </div>
          </div>
          <div class="fr ideamoney">{{item.ideamoney}}{{item.ideamoney === '面议'?'':'元/月'}}</div>
        </div>
        <div class="listBottom" v-if="item.job_confim.length > 0 || item.selftags.length > 0">
          <el-tag
            type="success"
            v-for="(labelItem, labelIndex) in item.job_confim"
            :key="labelIndex"
          >{{labelItem}}</el-tag>
          <el-tag v-for="(labelItem, labelIndex) in item.selftags" :key="labelIndex">{{labelItem}}</el-tag>
        </div>
      </div>
      <page :total="total" @getList="getList" />
    </div>
  </div>
</template>

<script>
import { toTime } from '@/js/common.js'
import page from "@/components/page";

export default {
  components: {
    page
  },
  data() {
    return {
      loading: true,
      total: 0,
      searchForm: {
        is_read: "",
        jid: "",
        page: 1,
        size: 10
      },
      is_readList: [
        {
          active: 1,
          name: "已阅"
        },
        {
          active: 2,
          name: "未阅"
        }
      ],
      jobList: [],
      list: []
    };
  },
  created() {
    this.getList();
    this.getJobList()
  },
  methods: {
    // 重置
    resetSearch() {
      this.searchForm = {
        is_read: "",
        jid: ""
      };
      this.getList()
    },

    // 获取列表
    getList(page) {
      if(page) {
        this.searchForm.page = page
      } else {
        this.searchForm.page = 1
      }
      this.loading = true
      this.api.get('/5cff829aa56af', this.searchForm).then(r => {
        this.loading = false
        this.list = r.data.list
        this.total = r.data.count
        this.list.forEach(o => {
          if (o.job_confim) {
            o.job_confim = JSON.parse(o.job_confim);
          }
          if (o.selftags) {
            o.selftags = JSON.parse(o.selftags);
          }
          o.createTime = toTime(o.createTime*1000 ,'yyyy年MM月dd日 hh:mm')
        });
      })
    },

    // 获取职位列表
    getJobList() {
      let obj = {
        page: 1,
        size: 100
      }
      this.api.get('/5cef405d39ad5', obj).then(r => {
        this.jobList = r.data.list
      })
    },

    // 简历详情
    goDetail(e) {
      let routeData = this.$router.resolve({
        path:'/boss/resumeDetail',
        query: {
          vid: e.vid?e.vid:'',
          source: 'school_receive_vita_list'
        }
      })
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.received {
  margin-top: 20px;
  padding: 20px;
  padding-bottom: 0;
  background: white;
}
.list {
  padding-top: 20px;
  .listBox {
    background: white;
    margin-top: 20px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    .createTime {
        position: absolute;
        right: 0;
        bottom: 0;
        color: #999;
        font-size: 14px;
    }
    .is_read {
        position: absolute;
        top: 6px;
        right: -18px;
        background: #ff5b12;
        color: white;
        transform: rotateZ(45deg);
        width: 70px;
        text-align: center;
    }
  }
  .listBox:hover {
    .vita_name {
      color: #fc703e;
    }
  }
  .listBox:first-child {
    margin-top: 0;
  }
  .listTop {
    padding: 20px 30px;
    .listTopBox {
      > div {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .listContent {
      margin-left: 5px;
      .listContentBox {
        padding-top: 5px;
        font-size: 14px;
        color: #61687c;
      }
    }
  }
  .ideamoney {
    color: #fc703e;
    line-height: 68px;
  }
  .listBottom {
    padding: 0 20px;
    padding-bottom: 10px;
    font-size: 0;
    span {
      font-size: 14px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/boss/received.vue